import { createStore } from 'vuex'

export default createStore({
  state: {
    recordDetail: {}
  },
  getters: {
  },
  mutations: {
    setRecordDetail (state, obj) {
      state.recordDetail = obj
    }
  },
  actions: {
  },
  modules: {
  }
})
